export const tags = ["nintendo", "indies", "favorite"];

export const videoLinks = [
  {
    id: 1,
    title: "Okami",
    link: "https://www.youtube.com/embed/RhnhRfTzRnw",
    image: "https://i3.ytimg.com/vi/RhnhRfTzRnw/maxresdefault.jpg",
    tags: [tags[0], tags[2]],
  },
  {
    id: 2,
    title: "Uncharted",
    link: "https://www.youtube.com/embed/LvC_K087qvk",
    image: "https://img.youtube.com/vi/LvC_K087qvk/maxresdefault.jpg",
    tags: [tags[0], tags[2]],
  },
  {
    id: 3,
    title: "Where is my Water?",
    link: "https://www.youtube.com/embed/X3HlksQQ7mE",
    image: "https://img.youtube.com/vi/X3HlksQQ7mE/maxresdefault.jpg",
    tags: [tags[0], tags[2]],
  },
  {
    id: 4,
    title: "Metro Last Light",
    link: "https://www.youtube.com/embed/7DUCA8wK9Ls",
    image: "https://img.youtube.com/vi/7DUCA8wK9Ls/maxresdefault.jpg",
    tags: [tags[0], tags[2]],
  },
  {
    id: 5,
    title: "Resident Evil 3",
    link: "https://www.youtube.com/embed/vXM0VzI2N4U",
    image: "https://img.youtube.com/vi/vXM0VzI2N4U/maxresdefault.jpg",
    tags: [tags[0], tags[2]],
  },
  {
    id: 6,
    title: "Stardew Valley",
    link: "https://www.youtube.com/embed/UzowO9v_-oc",
    image: "https://img.youtube.com/vi/UzowO9v_-oc/maxresdefault.jpg",
    tags: [tags[0], tags[2]],
  },
  {
    id: 7,
    title: "Plants vs Zombies",
    link: "https://www.youtube.com/embed/XCOEvqNDyrA",
    image: "https://img.youtube.com/vi/ssZoq1eUK-s/maxresdefault.jpg",
    tags: [tags[0], tags[2]],
  },
  {
    id: 8,
    title: "Dark Souls",
    link: "https://www.youtube.com/embed/9IbPrk-yuts",
    image: "https://img.youtube.com/vi/9IbPrk-yuts/maxresdefault.jpg",
    tags: [tags[0], tags[2]],
  },
  {
    id: 9,
    title: "SOMA",
    link: "https://www.youtube.com/embed/BZTfi1jv-EE",
    image: "https://img.youtube.com/vi/8uVzg4CJLzw/maxresdefault.jpg",
    tags: [tags[0], tags[2]],
  },
  {
    id: 10,
    title: "ICO",
    link: "https://www.youtube.com/embed/A-zXhIBO27k",
    image: "https://img.youtube.com/vi/A-zXhIBO27k/maxresdefault.jpg",
    tags: [tags[0], tags[2]],
  },
  {
    id: 11,
    title: "The Last Guardian",
    link: "https://www.youtube.com/embed/4cDuKShhQOA",
    image: "https://img.youtube.com/vi/4cDuKShhQOA/maxresdefault.jpg",
    tags: [tags[0], tags[2]],
  },
  {
    id: 12,
    title: "Bastion",
    link: "https://www.youtube.com/embed/TptJHeWngJs",
    image: "https://img.youtube.com/vi/TptJHeWngJs/maxresdefault.jpg",
    tags: [tags[0], tags[2]],
  },
  {
    id: 13,
    title: "Risk of Rain 2",
    link: "https://www.youtube.com/embed/IeLNqCrCtWs",
    image: "https://i3.ytimg.com/vi/IeLNqCrCtWs/maxresdefault.jpg",
    tags: [tags[0], tags[2]],
  },
  {
    id: 14,
    title: "Batman Arkham Asylum",
    link: "https://www.youtube.com/embed/essx3X6EjvM",
    image: "https://i3.ytimg.com/vi/essx3X6EjvM/maxresdefault.jpg",
    tags: [tags[0], tags[2]],
  },
  {
    id: 15,
    title: "Fire Emblem Three Houses",
    link: "https://www.youtube.com/embed/rkux5h0PeXo",
    image: "https://img.youtube.com/vi/rkux5h0PeXo/maxresdefault.jpg",
    tags: [tags[0], tags[2]],
  },
  {
    id: 16,
    title: "Wario Ware Gold",
    link: "https://www.youtube.com/embed/Q-rfeYhv2yw",
    image: "https://i3.ytimg.com/vi/Q-rfeYhv2yw/maxresdefault.jpg",
    tags: [tags[0], tags[2]],
  },
  {
    id: 17,
    title: "Resident Evil 4",
    link: "https://www.youtube.com/embed/u90nv3bfuB0",
    image: "https://i3.ytimg.com/vi/gklTUwy5k-c/maxresdefault.jpg",
    tags: [tags[1]],
  },
  {
    id: 18,
    title: "Untitled Goose Game",
    link: "https://www.youtube.com/embed/GrVNwqbH0kA",
    image: "https://i3.ytimg.com/vi/GrVNwqbH0kA/maxresdefault.jpg",
    tags: [tags[1]],
  },
  {
    id: 19,
    title: "Cuphead",
    link: "https://www.youtube.com/embed/XwF67xkNSn8",
    image: "https://i3.ytimg.com/vi/XwF67xkNSn8/maxresdefault.jpg",
    tags: [tags[1]],
  },
  {
    id: 20,
    title: "Black Future 88",
    link: "https://www.youtube.com/embed/M51eIzz-qGM",
    image: "https://i3.ytimg.com/vi/M51eIzz-qGM/maxresdefault.jpg",
    tags: [tags[1]],
  },
  {
    id: 21,
    title: "Bloodstained: Ritual of the Night",
    link: "https://www.youtube.com/embed/ziyxCRvqeIg",
    image: "https://i3.ytimg.com/vi/ziyxCRvqeIg/maxresdefault.jpg",
    tags: [tags[1]],
  },
  {
    id: 22,
    title: "Just Dance 2020",
    link: "https://www.youtube.com/embed/9BrAT_o7yWA",
    image: "https://i3.ytimg.com/vi/9BrAT_o7yWA/maxresdefault.jpg",
    tags: [tags[1]],
  },
  {
    id: 23,
    title: "Mario Kart Deluxe",
    link: "https://www.youtube.com/embed/tKlRN2YpxRE",
    image: "https://i3.ytimg.com/vi/tKlRN2YpxRE/maxresdefault.jpg",
    tags: [tags[1]],
  },
  {
    id: 24,
    title: "Shadow of the Colossus",
    link: "https://www.youtube.com/embed/pdZQ98mWeto",
    image: "https://i3.ytimg.com/vi/pdZQ98mWeto/maxresdefault.jpg",
    tags: [tags[1]],
  },
  {
    id: 25,
    title: "Shadow of the Tomb Raider",
    link: "https://www.youtube.com/embed/r_WbvIDAcA4",
    image: "https://i3.ytimg.com/vi/r_WbvIDAcA4/maxresdefault.jpg",
    tags: [tags[1]],
  },
  {
    id: 26,
    title: "Captain Toad",
    link: "https://www.youtube.com/embed/Y8zQxSWaotc",
    image: "https://i3.ytimg.com/vi/Y8zQxSWaotc/maxresdefault.jpg",
    tags: [tags[1]],
  },
  {
    id: 27,
    title: "Hyrule Warriors",
    link: "https://www.youtube.com/embed/ynRbfs7i7Q0",
    image: "https://i3.ytimg.com/vi/ynRbfs7i7Q0/maxresdefault.jpg",
    tags: [tags[1]],
  },
  {
    id: 28,
    title: "Terraria",
    link: "https://www.youtube.com/embed/9DwRYw2g9Sc",
    image: "https://i3.ytimg.com/vi/9DwRYw2g9Sc/maxresdefault.jpg",
    tags: [tags[1]],
  },
  {
    id: 29,
    title: "Inside",
    link: "https://www.youtube.com/embed/yDm6PAgNohU",
    image: "https://i3.ytimg.com/vi/yDm6PAgNohU/maxresdefault.jpg",
    tags: [tags[1]],
  },
  {
    id: 30,
    title: "Limbo",
    link: "https://www.youtube.com/embed/Y4HSyVXKYz8",
    image: "https://i3.ytimg.com/vi/Y4HSyVXKYz8/maxresdefault.jpg",
    tags: [tags[1]],
  },
  {
    id: 31,
    title: "Gris",
    link: "https://www.youtube.com/embed/gvECQlxrhbw",
    image: "https://i3.ytimg.com/vi/gvECQlxrhbw/maxresdefault.jpg",
    tags: [tags[1]],
  },
  {
    id: 32,
    title: "Burnout Paradise",
    link: "https://www.youtube.com/embed/V6FxvqAjT64",
    image: "https://i3.ytimg.com/vi/V6FxvqAjT64/maxresdefault.jpg",
    tags: [tags[1]],
  },
  {
    id: 33,
    title: "Katamari Damacy Reroll",
    link: "https://www.youtube.com/embed/JHsFcSNFUMc",
    image: "https://i3.ytimg.com/vi/JHsFcSNFUMc/maxresdefault.jpg",
    tags: [tags[1]],
  },
  {
    id: 34,
    title: "Hollow Knight",
    link: "https://www.youtube.com/embed/yQxwbZsL14Y",
    image: "https://i3.ytimg.com/vi/yQxwbZsL14Y/maxresdefault.jpg",
    tags: [tags[1]],
  },
  {
    id: 35,
    title: "Astral Chain",
    link: "https://www.youtube.com/embed/brmmV3g4qqo",
    image: "https://i3.ytimg.com/vi/brmmV3g4qqo/maxresdefault.jpg",
    tags: [tags[1]],
  },
  {
    id: 36,
    title: "Pokemon Sword & Shield",
    link: "https://www.youtube.com/embed/Upo7SWKJcyY",
    image: "https://i3.ytimg.com/vi/Upo7SWKJcyY/maxresdefault.jpg",
    tags: [tags[1]],
  },
  {
    id: 37,
    title: "Alien Isolation",
    link: "https://www.youtube.com/embed/rwq-Msina10",
    image: "https://i3.ytimg.com/vi/rwq-Msina10/maxresdefault.jpg",
    tags: [tags[2]],
  },
  {
    id: 38,
    title: "Good Job!",
    link: "https://www.youtube.com/embed/5c9QZFeVrRY",
    image: "https://i3.ytimg.com/vi/5c9QZFeVrRY/maxresdefault.jpg",
    tags: [tags[2]],
  },
  {
    id: 39,
    title: "Shinsekai: Into the Depths",
    link: "https://www.youtube.com/embed/1dJvMHToVA4",
    image: "https://i3.ytimg.com/vi/1dJvMHToVA4/maxresdefault.jpg",
    tags: [tags[2]],
  },
  {
    id: 40,
    title: "Going Under",
    link: "https://www.youtube.com/embed/nKLELV7YLns",
    image: "https://i3.ytimg.com/vi/nKLELV7YLns/maxresdefault.jpg",
    tags: [tags[2]],
  },
  {
    id: 41,
    title: "The Legend of Zelda: Link’s Awakening",
    link: "https://www.youtube.com/embed/PtC6U8hOZTk",
    image: "https://i3.ytimg.com/vi/PtC6U8hOZTk/maxresdefault.jpg",
    tags: [tags[2]],
  },
  {
    id: 42,
    title: "Ori and the Blind Forest",
    link: "https://www.youtube.com/embed/3rTtWcBATk4",
    image: "https://i3.ytimg.com/vi/3rTtWcBATk4/maxresdefault.jpg",
    tags: [tags[2]],
  },
  {
    id: 43,
    title: "Luigi's Mansion 3",
    link: "https://www.youtube.com/embed/8w9-31FrjU8",
    image: "https://i3.ytimg.com/vi/8w9-31FrjU8/maxresdefault.jpg",
    tags: [tags[2]],
  },
  {
    id: 44,
    title: "Donkey Kong Country: Tropical Freeze",
    link: "https://www.youtube.com/embed/_5p0SiWHwvw",
    image: "https://i3.ytimg.com/vi/_5p0SiWHwvw/maxresdefault.jpg",
    tags: [tags[2]],
  },
  {
    id: 45,
    title: "Kirby Star Allies",
    link: "https://www.youtube.com/embed/FNPf9KkL-ik",
    image: "https://i3.ytimg.com/vi/FNPf9KkL-ik/maxresdefault.jpg",
    tags: [tags[2]],
  },
  {
    id: 46,
    title:
      "Cadence of Hyrule - Crypt of the Necrodancer ft. The Legend of Zelda",
    link: "https://www.youtube.com/embed/oYd_pph6RnI",
    image: "https://i3.ytimg.com/vi/oYd_pph6RnI/maxresdefault.jpg",
    tags: [tags[2]],
  },
  {
    id: 47,
    title: "Yoshi's Crafted World",
    link: "https://www.youtube.com/embed/sx_C9jJ0AlA",
    image: "https://i3.ytimg.com/vi/sx_C9jJ0AlA/maxresdefault.jpg",
    tags: [tags[2]],
  },
  {
    id: 48,
    title: "Paper Mario: The Origami King",
    link: "https://www.youtube.com/embed/FX6DTLcWUdY",
    image: "https://i3.ytimg.com/vi/FX6DTLcWUdY/maxresdefault.jpg",
    tags: [tags[2]],
  },
  {
    id: 49,
    title: "Animal Crossing: New Horizons ",
    link: "https://www.youtube.com/embed/KpZyexo-ziA",
    image: "https://i3.ytimg.com/vi/KpZyexo-ziA/maxresdefault.jpg",
    tags: [tags[2]],
  },
  {
    id: 50,
    title: "The Legend of Zelda: Breath of the Wild",
    link: "https://www.youtube.com/embed/zw47_q9wbBE",
    image: "http://i3.ytimg.com/vi/zw47_q9wbBE/maxresdefault.jpg",
    tags: [tags[0]],
  },
];
